export default "__VITE_ASSET__axUjQDpE__"